module.exports = __webpack_public_path__ + "static/media/diamonds_3.d61f7eaf.png";